import { useState } from 'react';
import { ScanStatus } from '../interfaces'; // Adjust the import path as necessary
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useDeviceScan = () => {
  const [scanStatus, setScanStatus] = useState<ScanStatus | null>(null);
  const [error, setError] = useState<string | null>(null); // Allow error to be a string or null
    const { sessionState } = useSession();

  const startScan = async (fromDate: string) => {
    try {
      const token = sessionState.account?.token;
      if (!token) {
        setError('Login or token is missing');
        return;
      }
      const queryParams = fromDate ? `?fromDate=${encodeURIComponent(fromDate)}` : '';
      const response = await fetch(`${config.centralApiBaseUrl}/device/ean/scan/start${queryParams}`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.ok) {
        setError(null);
        // Start polling the scan progress after starting the scan
        pollScanProgress();
      } else {
        throw new Error('Failed to start scan');
      }
    } catch (err) {
      // Ensure that the error is set as a string
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  const pollScanProgress = async () => {
    try {
      const token = sessionState.account?.token;
      const response = await fetch(`${config.centralApiBaseUrl}/device/ean/scan/progress`, {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data: ScanStatus = await response.json();
        setScanStatus(data);


        // Stop polling if total is 0 or total equals processed
        if (data.totalEans === 0 || data.processedEans >= data.totalEans || data.status === 'Done') {
            return;
        }
        setTimeout(pollScanProgress, 2000);
      } else {
        throw new Error('Failed to fetch scan progress');
      }
    } catch (err) {
      // Ensure that the error is set as a string
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  return { scanStatus, error, startScan };
};

export default useDeviceScan;
